import styled, { css, keyframes } from 'styled-components';
import { PriceTag3 } from '@styled-icons/remix-fill';
import { rgba } from 'polished';
import { Wrapper as Form } from 'v3/components/SidebarBox/styles';
import UnstyledPromotionalModal from 'v3/components/PromotionalModal';
import { SpinnerIos } from '@styled-icons/fluentui-system-regular/SpinnerIos';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    @media (max-width: 992px) {
      ${Form} {
        padding: 0;
        border: none;
        background-color: ${theme.colors.neutralSilver5};
      }
    }
  `}
`;

export const TitleSection = styled.section`
  margin-bottom: 40px;
`;

export const SectionTitle = styled.h3`
  font-size: 1.6rem;
  font-weight: 600;
  color: #121212;
  margin-bottom: 8px;

  > span {
    font-weight: 400;
    color: #626262;
  }
`;

export const SectionSubTitle = styled.p`
  font-size: 1.4rem;
  font-weight: 400;
  color: #626262;
  line-height: 1.5;
  margin-bottom: 8px;
`;

export const Description = styled.p`
  font-size: 1.4rem;
  font-weight: 400;
  color: #626262;
  line-height: 1.5;
  margin-bottom: 8px;
`;

export const FieldWrapper = styled.div`
  position: relative;

  .pac-container.pac-logo {
    top: 80px !important;
    left: 0 !important;
  }

  .pac-item:nth-child(n + 5) {
    display: none;
  }

  @media (max-width: 992px) {
    .pac-item {
      line-height: 43px;
    }

    .pac-icon {
      margin-top: 11px;
    }
  }
`;

export const PersonalInfo = styled.section`
  margin-bottom: 0;
`;

export const PersonalInfoContent = styled.section`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const PersonalInfoGridContent = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px 40px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 24px;
  }
`;

export const Address = styled.section`
  margin-bottom: 0;
`;

export const AddressContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const SSN = styled.section`
  margin-bottom: 0;
`;

export const PasswordIcons = styled.div`
  cursor: pointer;
  line-height: 1;
  margin-right: 8px;
`;

export const Promo = styled.section`
  margin-bottom: 0;
`;

export const Checkboxes = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 0;
`;

export const ButtonSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 24px;

  @media (max-width: 576px) {
    flex-direction: column-reverse;

    > button {
      width: 100%;
    }
  }
`;

export const ReferralCodeApplication = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  flex-wrap: wrap;
`;

export const PriceTagContent = styled.div`
  ${({ theme }) => css`
    font-size: 1.4rem;
    color: ${theme.colors.neutralSilver60};
    display: flex;
    align-items: center;
  `}
`;

export const PriceTag = styled(PriceTag3)`
  ${({ theme }) => css`
    color: ${theme.colors.statusSuccess30};
  `}
`;

export const ReferralCodeDetail = styled.span`
  ${({ theme }) => css`
    font-size: 1.4rem;
    font-weight: 500;
    color: ${theme.colors.neutralSilver70};
  `}
`;

export const ToastWrapper = styled.div`
  ${({ theme }) => css`
    p {
      font-size: 1.6rem;
      font-weight: 700;
      line-height: 24px;
      color: ${theme.colors.neutralGray60};
      margin-bottom: 0;
    }

    span {
      display: block;
      font-size: 1.4rem;
      color: ${theme.colors.neutralGray60};
    }

    a {
      text-decoration: none;
      font-weight: 700;
      color: ${theme.colors.primary100};

      &:hover {
        color: ${rgba(theme.colors.primary100, 0.6)};
      }
    }
  `}
`;

export const PromotionalModal = styled(UnstyledPromotionalModal)`
  img {
    max-width: 170px;
  }
`;

export const PromotionalModalContent = styled.div`
  > div {
    max-width: 283px;
  }
`;

export const LoadingButtonContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const ProcessingIcon = styled(SpinnerIos)`
  animation: 2s linear ${spin} infinite;
`;

// --- Light DS "Personal info" reskin (Painel B), portado do design do site ---

export const InfoPane = styled.div`
  font-family: 'Inter', sans-serif;
  max-width: 576px;
  width: 100%;
  margin: 0 auto;
  padding: 32px 24px;

  @media (min-width: 768px) {
    padding: 40px 24px;
  }
`;

export const Eyebrow = styled.p`
  font-size: 1.4rem;
  font-weight: 600;
  line-height: 1.5;
  margin: 0 0 16px 0;

  .phase {
    color: #362d70;
  }

  .rest {
    color: #626262;
  }
`;

export const InfoTitle = styled.h1`
  font-size: 2.8rem;
  font-weight: 600;
  line-height: 1.2;
  color: #121212;
  margin: 0 0 24px 0;

  @media (max-width: 576px) {
    font-size: 2.4rem;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const FieldHint = styled.p`
  font-size: 1.4rem;
  color: #626262;
  line-height: 1.5;
  margin: 6px 0 0 0;
`;

export const FcraDisclaimer = styled.p`
  font-size: 1.4rem;
  color: #626262;
  line-height: 1.5;
  margin: 0 0 12px 0;
`;

export const LockIcon = styled.div`
  position: absolute;
  left: 14px;
  top: 22px;
  transform: translateY(-50%);
  color: #9da4b2;
  pointer-events: none;
  display: flex;
  z-index: 1;

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const ConsentBox = styled.div<{ $invalid?: boolean }>`
  border: 1px solid ${({ $invalid }) => ($invalid ? '#dc5252' : '#e5e5e5')};
  background: ${({ $invalid }) => ($invalid ? 'rgba(220, 82, 82, 0.06)' : '#fff')};
  border-radius: 8px;
  padding: 12px 14px;
  transition: border-color 0.15s ease, background-color 0.15s ease;

  /* Checkbox no estilo do design da Bianca: quadradinho pequeno alinhado ao
     topo do texto (consent multi-linha) + texto no tom secundario. O marcado
     roxo (#362d70) vem do override do CardShell. */
  label {
    min-height: 0;
  }
  label > div {
    align-items: flex-start;
    padding-left: 30px;
  }
  label > div > span {
    width: 18px;
    height: 18px;
    top: 1px;
    border-color: #e5e5e5;
  }
  label > div > span::after {
    top: 3px;
  }
  label p {
    font-size: 1.4rem;
    line-height: 1.5;
    color: #626262;
    margin-top: 0;
  }
`;

export const BackContent = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #362d70;
  font-weight: 600;
`;

// Light card (StepFrame). Styles over <SidebarBox> without touching the shared
// component: overrides scoped to this panel only.
export const CardShell = styled.div`
  > form {
    border: 1px solid #e5e5e5;
    border-radius: 16px;
    background: #fff;
    box-shadow: 0 16px 40px rgba(54, 46, 112, 0.1);
    padding: 28px 36px;

    @media (max-width: 576px) {
      padding: 24px;
    }

    label {
      font-family: 'Inter', sans-serif;
      font-size: 1.4rem;
      font-weight: 600;
      color: #121212;
    }

    input,
    select {
      height: 44px;
      box-sizing: border-box;
      border-radius: 8px;
      font-family: 'Inter', sans-serif;
      font-size: 1.6rem;
      color: #121212;
    }

    /* The Select component brings its own padding/line-height, which leaves the box
       tall and the text low. Normalised to a clean 44px field with a centred arrow. */
    select {
      height: 44px !important;
      line-height: normal !important;
      padding: 0 40px 0 14px !important;
      background-position: center right 14px !important;
    }

    input:focus,
    select:focus {
      outline: none;
      box-shadow: 0 0 0 2px rgba(82, 98, 170, 0.35);
    }

    input::placeholder {
      color: #9da4b2;
    }

    .ssn-field input {
      padding-left: 40px;
    }

    /* Flat primary button (brand purple), no gradient, 8px corners. */
    button[type='submit'] {
      background: #362d70 !important;
      border-radius: 8px !important;
    }
    button[type='submit']:hover {
      background: #2c2560 !important;
    }

    /* Checked checkbox in the brand purple (was the theme's blue-purple). */
    input:checked ~ span {
      background-color: #362d70 !important;
    }
  }
`;
